import { createSelector, MemoizedSelector } from '@ngrx/store';
import { SearchState, StateWithSearch } from '../search-state';
import { getCustomSearchState } from './feature.selector';

export const getSearchHistoryState: MemoizedSelector<StateWithSearch, SearchState['searchHistory']> = createSelector(
  getCustomSearchState,
  (state: SearchState) => state.searchHistory,
);
